export const PAGE_CLASSIFY = 'classify';
export const PAGE_CONCIERGE = 'concierge';
export const PAGE_GUARANTEED_HIRE = 'guaranteed-hire';
export const PAGE_PREMIUM_PLUS = 'premium-plus';
export const PAGE_MANAGE = 'shortlist';
export const PAGE_MULTI_LOCATION = 'multi-location';
export const PAGE_PAY_AND_POST = 'checkout';
export const PAGE_ROLE_REQS = 'shortlist';
export const PAGE_SELECT_AD = 'select-ad';
export const PAGE_SUCCESS = 'checkout-complete';
export const PAGE_WRITE = 'write';
export const PAGE_EDIT = 'job edit ad';
export const PAGE_EDIT_PAY_AND_POST = 'pay and post';
export const PAGE_REFRESH = 'job refresh ad';
export const PAGE_REFRESH_ERROR = 'job refresh ad error';

// Need to verify page IDs and continue link event names
export const CLASSIFY_CONTINUE = 'classify_continue_pressed';
export const SELECT_AD_CONTINUE = 'select_ad_continue_pressed';
export const ROLE_REQS_CONTINUE = 'shortlist_continue_pressed';
export const WRITE_CONTINUE = 'write_continue_pressed';
export const MANAGE_CONTINUE = 'shortlist_continue_pressed';
export const DEFAULT_CONTINUE = 'continue_pressed';

// Page event names
export const EVENT_CAJA_START = 'ecaja_start';
export const EVENT_VIEW_CLASSIFY = 'ecaja_classify_displayed';
export const EVENT_VIEW_CONCIERGE = 'ecaja_concierge_displayed';
export const EVENT_VIEW_GUARANTEED_HIRE = 'ecaja_guaranteed_hire_displayed';
export const EVENT_VIEW_MULTI_LOCATION = 'add_multi_locations_displayed';
export const EVENT_VIEW_PAY_AND_POST = 'ecaja_checkout_displayed';
export const EVENT_VIEW_ROLE_REQS = 'ecaja_role_req_displayed';
export const EVENT_VIEW_PREMIUM_PLUS = 'ecaja_premium_plus_displayed';
export const EVENT_NAME_VIEW_REFRESH = 'job_refresh_ad_displayed';
export const EVENT_NAME_VIEW_REFRESH_ERROR = 'refresh_error_displayed';
export const EVENT_VIEW_SELECT_AD = 'ecaja_select_ad_displayed';
export const EVENT_VIEW_EDIT = 'job_edit_displayed';
export const EVENT_VIEW_EDIT_PAY_AND_POST = 'pay_and_post_displayed';
export const EVENT_VIEW_SUCCESS = 'ecaja_completed_page_displayed';
export const EVENT_VIEW_WRITE = 'ecaja_write_displayed';
export const EVENT_FIND_CANDIDATES_WIDGET_DISPLAYED =
  'find_candidates_widget_displayed';

// Save draft event
export const ANALYTICS_SAVE_DRAFT = 'job_ad_save_pressed';

// Progress bar
export const NAVIGATION_BAR_EVENT = 'navigation_bar_pressed';

// Multilocation page link events
export const ADD_LOCATION_PRESSED = 'add_location_pressed';
export const MULTILOCATION_SUBMIT_PRESSED = 'multi_locations_submit_pressed';
export const MULTILOCATION_FAILED = 'multi_locations_add_failed';
export const MULTILOCATION_ADD_SUCCEEDED = 'multi_locations_add_succeeded';
export const MULTILOCATION_POSTED_PARTIAL_SUCCEEDED =
  'multi_location_posted_partial_succeeded';

// Classify page link events
export const JOB_TITLE_PRESSED = 'job_title_pressed';
export const TOOLTIP_PRESSED = 'tooltip_pressed';
export const LOCATION_PRESSED = 'location_pressed';
export const CATEGORY_PRESSED = 'category_pressed';
export const CATEGORY_OTHER_PRESSED = 'category_other_pressed';
export const WORK_TYPE_PRESSED = 'work_type_pressed';
export const PAY_TYPE_PRESSED = 'pay_type_pressed';
export const PAY_RANGE_PRESSED = 'pay_range_pressed';
export const PAY_DISPLAYED_PRESSED = 'pay_displayed_pressed';
export const PRICE_PANEL_DISPLAYED = 'price_panel_displayed';
export const USE_PREVIOUS_JOB_PRESSED = 'use_previous_job_pressed';
export const TOGGLE_PRESSED = 'toggle_pressed';
export const SALARY_HIDE = 'hide_salary';
export const PRIVATE_JOB = 'private ad';
export const RESEND_VERIFICATION_EMAIL_PRESSED =
  'resend_verification_email_pressed';

// Pay And Post page events

export const APPLY_PROMO_CODE_PRESSED = 'apply_promo_code_pressed';
export const NAVIGATION_PRESSED = 'navigation_pressed';
export const ADBUDGET_UPSELL_DISPLAYED = 'adbudget_upsell_displayed';
export const BUSINESS_ADDRESS_PRESSED = 'business_address_pressed';
export const FAQ_PRESSED = 'faq_pressed';
export const POST_AD_PRESSED = 'post_ad_pressed';
export const CREDIT_HOLD_HELP_CENTRE_PRESSED =
  'credit_hold_help_centre_pressed';
export const CREDIT_HOLD_OUTSTANDING_INVOICES_PRESSED =
  'credit_hold_outstanding_invoices_pressed';
export const PAY_BY_INVOICE_PRESSED = 'pay_by_invoice_pressed';
export const PAY_BY_CREDIT_CARD_PRESSED = 'pay_by_credit_card_pressed';
export const REPLACE_CREDIT_CARD_PRESSED = 'replace_credit_card_pressed';

// Premium upsell component

export const PREMIUM_UPSELL_DISPLAYED = 'premium_upsell_displayed';
export const PREMIUM_UPSELL_PRESSED = 'premium_upsell_pressed';

// Preview events
export const JOB_PREVIEW_PRESSED = 'job_preview_pressed';
export const OBJECT_PRESSED = 'object_pressed';
export const PREVIEW_SEARCH_RESULT_PRESSED = 'preview_search_results_pressed';
export const PREVIEW_PRINT_SEARCH_RESULTS_PRESSED =
  'preview_print_search_results_pressed';
export const PREVIEW_JOB_DETAILS_PRESSED = 'preview_job_details_pressed';
export const PREVIEW_PRINT_JOB_DETAILS_PRESSED =
  'preview_print_job_details_pressed';
export const PHONE_NUMBER_PRESSED = 'phone_number_pressed';

// Email verification
export const CONTENT_ELEMENT_PRESSED = 'content_element_pressed';
export const ALERT_VIEWED = 'alert_viewed';

// Manage page link events
export const JOB_AD_REFERENCE_CLICKED = 'job_ad_reference_pressed';
export const JOB_AD_REFERENCE_HELP_TEXT_EXPAND = 'tooltip-expanded';
export const JOB_AD_REFERENCE_HELP_OBJECT_INTERACTION = 'job-reference-help';
export const LINKOUT_APPLY_CLICKED = 'shortlist_linkout_apply_pressed';
export const ROLE_REQS_CONTINUE_INTERACTION = 'shortlist-continue';

// Job ad booking page link events
export const JOB_AD_BOOKING_FORM_SUBMIT_PRESSED = 'booking_form_submit_pressed';
export const JOB_AD_BOOKING_FORM_SUBMIT_SUCCEEDED =
  'booking_form_submit_succeeded';
export const JOB_AD_BOOKING_FORM_SUBMIT_FAILED = 'booking_form_submit_failed';

// Write page link events
export const GUIDED_WRITING_PRESSED = 'guided_writing_pressed';
export const STANDARD_WRITING_PRESSED = 'standard_writing_pressed';
export const JOB_DESCRIPTION_PRESSED = 'job_description_pressed';
export const JOB_DESCRIPTION_INTERACTION = 'job-description';
export const VIDEO_VALIDATION_SUCCEEDED = 'video_validation_succeeded';
export const VIDEO_PRESSED = 'object_pressed';
export const VIDEO_REMOVE_PRESSED = 'video_remove_pressed';
export const ABOUT_THE_BUSINESS_PRESSED = 'about_the_business_pressed';
export const ABOUT_THE_BUSINESS_INTERACTION = 'about-the-business';
export const JOB_SUMMARY_PRESSED = 'job_summary_pressed';
export const JOB_SUMMARY_INTERACTION = 'job-summary';
export const BRANDING_CONTEXTUAL_HELP = 'branding-contextual-help';
export const JOB_AD_DETAILS_ITEM_PRESSED = 'job_ad_details_item_pressed';
export const RESPONSIBILITIES_INTERACTION = 'tasks-responsibilities';
export const QUALIFICATIONS_INTERACTION = 'qualifications-experience';
export const BENEFITS_INTERACTION = 'benefits';
export const LINK_ACTION_ADD = 'add';
export const LINK_ACTION_REMOVE = 'remove';
export const KEY_SELLING_POINT_PRESSED = 'key_selling_point_pressed';
export const LOGO_ADD_PRESSED = 'logo_add_pressed';
export const LOGO_REPLACE_PRESSED = 'logo_replace_pressed';
export const EXISTING_BRAND_PRESSED = 'existing_brand_pressed';
export const CREATE_NEW_BRAND_PRESSED = 'create_new_brand_pressed';
export const BRAND_UPLOAD_SUCCEEDED = 'brand_upload_succeeded';
export const BRANDING_DISPLAYED = 'branding_displayed';
export const LOGO_PRESSED = 'logo_pressed';
export const BRAND_CREATE_FROM_CAJA = 'brand-create-from-caja';
export const BRAND_EDIT_FROM_CAJA = 'brand-edit-from-caja';
export const WRITE_CONTINUE_INTERACTION = 'write-continue';

// Edit page events
export const JOB_PUBLISH_PRESSED = 'job_publish_pressed';
export const JOB_CHECKOUT_PRESSED = 'job_checkout_pressed';
export const JOB_SECTION_DISPLAYED = 'job_section_displayed';
export const DISCARD_CHANGES_PRESSED = 'discard_changes_pressed';
export const KEEP_EDITING_PRESSED = 'keep_editing_pressed';
export const PRODUCT_EVENTS_PURCHASE = 'purchase';

// Success page link events
export const ADD_COVER_IMAGE_CTA_PRESSED = 'add_cover_image_cta_pressed';
export const JOB_AD_PRESSED = 'job_ad_pressed';
export const NOTIFICATION_SET_PREFERENCES_BTN_PRESSED =
  'notifications_set_preferences_btn_pressed';
export const NOTIFICATION_WIDGET_ADD_TEAM_DISPLAYED =
  'notifications_widget_add_team_displayed';
export const NOTIFICATION_WIDGET_SELF_PREFERENCE_DISPLAYED =
  'notifications_widget_self_preference_displayed';
export const NOTIFICATION_WIDGET_NOTIFY_TEAM_DISPLAYED =
  'notifications_widget_notify_team_displayed';
export const NOTIFICATION_WIDGET_CUSTOM_EMAIL_DISPLAYED =
  'notifications_widget_custom_email_displayed';
export const NOTIFICATION_SELF_CONFIRM_BTN_PRESSED =
  'notifications_self_confirm_btn_pressed';

export const NOTIFICATIONS_ADD_TEAM_MEMBERES_NOW_LINK_PRESSED =
  'notifications_add_team_members_now_link_pressed';

export const NOTIFICATIONS_TEAM_SELECT_BACK_BTN_PRESSED =
  'notifications_team_select_back_btn_pressed';

export const NOTIFICATIONS_TEAM_EMAIL_CONFIRM_BTN_PRESSED =
  'notifications_team_email_confirm_btn_pressed';
export const BUY_AN_ADPACK_PRESSED = 'buy_an_adpack_pressed';

export const NOTIFICATIONS_TEAM_EMAIL_BACK_BTN_PRESSED =
  'notifications_team_email_back_btn_pressed';

export const NOTIFICATION_TEAM_SELECT_CONFIRM_BTN_PRESSED =
  'notifications_team_select_confirm_btn_pressed';

export const FIND_MORE_CANDIDATES_PRESSED = 'find_more_candidates_pressed';

// Refresh page events
export const JOB_REFRESH_ALERT_VIEWED = 'alert_viewed';

// Refresh page link events
export const JOB_REFRESH_AD_PRESSED = 'job_refresh_ad_pressed';
export const JOB_REFRESH_ERROR_CTA_PRESSED = 'cta_pressed';
export const PREVIEW_SEARCH_RESULTS_PRESSED = 'preview_search_results_pressed';

// Generic constants
export const EVENT_NAME_CONTRACT_PURCHASE_VIEWED =
  'seek-contract-purchase-viewed';
export const PRODUCT_QUANTITIES_JOB_AD_QUANTITY = '1';
